import md5 from "md5";

/**
 * @description 加密
 * @param data
 * @returns {*}
 */
export function encryption(data) {
  return md5(data);
}
